import 'jquery-match-height/dist/jquery.matchHeight.js';
import 'fullpage.js/dist/jquery.fullpage.js';
import 'jquery/dist/jquery.js';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.same-height-garment').matchHeight();
    $('#fullpage').fullpage({
      verticalCentered: true,
      // anchors: ['anchor1', 'anchor2', 'anchor3'],
      menu: '#menu',
      // sectionsColor: ['#1bbc9b', '#4BBFC3', '#7BAABE'],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js